import { useEffect } from "react";

interface PageMetaProps {
  title: string;
  description: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

export default function PageMeta({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogImage = "https://furbaby.vet/main/og-image.png",
}: PageMetaProps) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? "property" : "name";
      let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
      return el;
    };

    const setLink = (rel: string, href: string) => {
      let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
      return el;
    };

    const metas: HTMLMetaElement[] = [];
    const links: HTMLLinkElement[] = [];

    metas.push(setMeta("description", description));
    metas.push(setMeta("og:title", ogTitle ?? title, true));
    metas.push(setMeta("og:description", ogDescription ?? description, true));
    metas.push(setMeta("og:image", ogImage, true));
    metas.push(setMeta("twitter:title", ogTitle ?? title));
    metas.push(setMeta("twitter:description", ogDescription ?? description));
    metas.push(setMeta("twitter:image", ogImage));

    if (canonical) {
      links.push(setLink("canonical", canonical));
    }

    return () => {
      document.title = prev;
    };
  }, [title, description, canonical, ogTitle, ogDescription, ogImage]);

  return null;
}
